module.exports = __webpack_public_path__ + "static/img/01.43508d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ITWE/01.jpg
// module id = rOWZ
// module chunks = 1